import { Environment } from '@thiememeulenhoff/types';

export interface SecurityConfig {
  environment: Environment;
  clientId: string;
  clientSecret: string;
  interceptorUrlWhitelist?: Array<string>;
  debug?: boolean;
  enableInterceptor?: boolean;
  enableCallback?: boolean;
  callbackPath?: string;
  useUserCookie?: boolean;
  useWebappPlatformCall?: boolean;
}

export const PLATFORM_TOKEN = 'platform_token';
